import { useQuery } from "@tanstack/react-query"
import { getNodeSelf } from "../services/query_service"

export const useNodeSelfQuery = () => {
    return useQuery({
        queryKey: ['node', 'self'],
        queryFn: async () => getNodeSelf(),
        staleTime: 1000 * 60 * 60, // 60 minutes
    })
}